import { combineReducers } from 'redux';
import {
  AVAILABLE_PARKING_SITES,
  PARKING_LOCATION,
  SELECTED_VEHICLE_TYPE,
  SET,
  UNSET,
  SHOW_PARKING_DETAIL_CARD,
  SHOW_MY_BOOKING_MODAL,
} from './type';
import {
  LocObjType,
  MyBookingModal,
  ParkingDetailModal,
  ParkingType,
  ParkingVehicleType,
} from '../types/types';
import { LOCATION_STATUS_TYPES } from 'core-lib/utils/location';

const INITIAL_LOC_OBJ: LocObjType = {
  hasLocation: false,
  activeLocType: 'device',
  searchLoc: {
    coords: {
      lat: null,
      lng: null,
    },
    formattedAddress: '',
  },
  deviceLoc: {
    status: LOCATION_STATUS_TYPES.Pending,
    coords: {
      lat: null,
      lng: null,
    },
    formattedAddress: '',
  },
};

const INITIAL_PARKING_MODAL: ParkingDetailModal = {
  isOpen: false,
  selectedSite: null,
};

const INITIAL_MY_BOOKING_MODAL: MyBookingModal = {
  isOpen: false,
};

const parkingDetailModal = (state = INITIAL_PARKING_MODAL, action) => {
  switch (action.type) {
    case SHOW_PARKING_DETAIL_CARD[SET]:
      return { ...state, isOpen: true, selectedSite: action.data };
    case SHOW_PARKING_DETAIL_CARD[UNSET]:
      return INITIAL_PARKING_MODAL;
    default:
      return state;
  }
};

const myBookingModal = (state = INITIAL_MY_BOOKING_MODAL, action) => {
  switch (action.type) {
    case SHOW_MY_BOOKING_MODAL[SET]:
      return { ...state, isOpen: true };
    case SHOW_MY_BOOKING_MODAL[UNSET]:
      return INITIAL_MY_BOOKING_MODAL;
    default:
      return state;
  }
};

const selectedVehicleType = (state = ParkingVehicleType.CAR, action) => {
  switch (action.type) {
    case SELECTED_VEHICLE_TYPE[SET]:
      return action.data;
    case SELECTED_VEHICLE_TYPE[UNSET]:
      return null;
    default:
      return state;
  }
};

const parkingLocation = (state = INITIAL_LOC_OBJ, action) => {
  switch (action.type) {
    case PARKING_LOCATION[SET]:
      return { ...state, ...action.data };
    case PARKING_LOCATION[UNSET]:
      return INITIAL_LOC_OBJ;
    default:
      return state;
  }
};

const availableParkingLocations = (state: ParkingType[] = [], action) => {
  switch (action.type) {
    case AVAILABLE_PARKING_SITES[SET]:
      return action.data;
    case AVAILABLE_PARKING_SITES[UNSET]:
      return [];
    default:
      return state;
  }
};
export default function parkingV2Reducer() {
  return combineReducers({
    selectedVehicleType,
    parkingLocation,
    availableParkingLocations,
    parkingDetailModal,
    myBookingModal,
  });
}
